// revised request code

import { BOI_WALLET_USER_STORAGE } from '../constants';
import { DEFAULT_HEADERS } from '../constants/apiRequest/requestConstants/requestHeaderConstants';
import { routes } from '../routes';
import { getAccessToken, getItemFromSessionStorage } from './index';

const formatPayload = payload => {
  return payload ? { body: JSON.stringify(payload) } : {};
};

const setAuthorizationToken = authToken => {
  return authToken ? { Authorization: `Bearer ${authToken}` } : {};
};

const redirectToLoginPage = (history = {}) => {
  if (typeof history?.push === 'function') history.push(routes.loginPage.url);
};

const redirectToHomePageWithCacheRefresh = () => {
  window.location.replace(`${process.env.PUBLIC_URL}/`);
};

const retrieveAuthToken = () => {
  return getItemFromSessionStorage(getAccessToken(JSON.parse(getItemFromSessionStorage(BOI_WALLET_USER_STORAGE)))) || '';
};

const STATUS_HANDLERS = {
  401: (history) => redirectToLoginPage(history),
  412: () => redirectToHomePageWithCacheRefresh(),
  504: (_, response) => ({ ...response, error: true })
};

const fetchApi = async (url, options = {}) => {
  const settings = {
    ...options, headers: {
      ...DEFAULT_HEADERS,
      ...options.headers
    }
  };
  const basePath = process.env.REACT_APP_API_ENDPOINT || `/`;
  const endpoint = basePath + url;
  const resp = await fetch(endpoint, settings);

  if (!resp.ok) {
    const errorResp = new Error(`Https error: ${resp.status}`);
    errorResp.status = resp.status;
    throw errorResp;
  }

  return resp.json();
};

// eslint-disable-next-line no-unused-vars
export const makeRequest = async ({ method, url, payload, settingsOverride = {}, history = {} }) => {
  const headers = setAuthorizationToken(retrieveAuthToken());
  try {
    return await fetchApi(url, { method, headers, ...formatPayload(payload), ...settingsOverride });
  } catch (err) {
    const errorHandler = STATUS_HANDLERS[err.status];
    if (errorHandler) return errorHandler();
    return { error: true, errorMessage: err.message };
  }
};
